
import { supabase } from '../integrations/supabase/client';

export const imageStorageService = {
  // Upload image to Supabase Storage for target impressions
  uploadTargetImage: async (file: File, userId: string, targetCode: string): Promise<string | null> => {
    try {
      console.log('📦 imageStorageService: Uploading target image:', { fileName: file.name, size: file.size, targetCode });
      
      // Create a unique file path with user/target folder structure
      const fileExt = file.name.split('.').pop();
      const fileName = `${Date.now()}-${Math.random().toString(36).substring(2)}.${fileExt}`;
      const filePath = `${userId}/${targetCode}/${fileName}`;

      const { data, error } = await supabase.storage
        .from('target-images')
        .upload(filePath, file, {
          cacheControl: '3600',
          upsert: false
        });

      if (error) {
        console.error('❌ imageStorageService: Upload error:', error);
        return null;
      }

      console.log('✅ imageStorageService: Image uploaded successfully:', data.path);
      return data.path;
    } catch (error) {
      console.error('❌ imageStorageService: Exception uploading image:', error);
      return null;
    }
  },

  // Get public URL for uploaded image
  getPublicUrl: (filePath: string): string => {
    const { data } = supabase.storage
      .from('target-images')
      .getPublicUrl(filePath);
    
    return data.publicUrl;
  },

  // Delete image from storage
  deleteImage: async (filePath: string): Promise<boolean> => {
    try {
      const { error } = await supabase.storage
        .from('target-images')
        .remove([filePath]);

      if (error) {
        console.error('❌ imageStorageService: Delete error:', error);
        return false;
      }

      return true;
    } catch (error) {
      console.error('❌ imageStorageService: Exception deleting image:', error);
      return false;
    }
  }
};
